// @flow

import * as React from 'react';
import { localize } from '@ta/common.i18n';
import { Link } from '@ta/common.routing';
import { Icon } from '@ta/styleguide.icon';
import { ClickTracker } from '@ta/common.tracking';
import { TripSearchGeoPillBinding } from '@ta/brand.geopill-util';
import { GeoPillRedCarpet } from '@ta/brand.trip-search-geopill-flyout';
import { GeoPillSponsor } from '@ta/brand.sponsored-geopill';
import styles from './TripSearchGeoPill.less';

type Props = {|
  /** The name of the current geopill, if applicable. */
  geoName?: string,

  /** Whether or not we are geoscoped. */
  isGeoScoped: boolean,

  /** Whether or not the user is scoped to nearby (has lat/lng in the URL) */
  isNearby: boolean,

  /** Name of the current servlet, for tracking. */
  servletName: string,
|};

class TripSearchGeoPill extends React.Component<Props> {
  static defaultProps = {
    geoName: undefined,
  };

  constructor(props: Props) {
    super(props);
    this.containerEl = React.createRef();
  }
  containerEl: any;

  render() {
    let geoPillText;
    if (this.props.isNearby) {
      geoPillText = localize('mx_nearby');
    } else if (this.props.isGeoScoped) {
      geoPillText = this.props.geoName;
    } else {
      geoPillText = localize('mobile_discovery_where_to');
    }

    // We set rootMargin-bottom to some arbitrarily high number so that we don't show the geopill until you scroll past them, as opposed to showing before them.
    return (
      <React.Fragment>
        <GeoPillSponsor adAreaId="tripsearch">
          {sponsorDataProvider => (
            <div className={styles.container} ref={this.containerEl} data-test-tripsearch-geopill>
              <ClickTracker
                module={`HomeNav_${this.props.servletName}`}
                action="click"
                context="GeoPicker"
              >
                <GeoPillRedCarpet
                  isGeoScoped={this.props.isGeoScoped}
                  isNearby={this.props.isNearby}
                  sponsorDataProvider={sponsorDataProvider}
                >
                  {targetRef => (
                    <div
                      ref={targetRef}
                      className={styles.pillWrap}
                      /* pre-fetching sponsor data by requesting it on user's click */
                      onClick={sponsorDataProvider}
                    >
                      <div className={`ui_pill ${styles.pill}`}>
                        {geoPillText}
                        <Icon name="single-chevron-down" className={styles.icon} />
                      </div>
                    </div>
                  )}
                </GeoPillRedCarpet>
              </ClickTracker>
              {(this.props.isGeoScoped || this.props.isNearby) && (
                <Link href="/">
                  <div className={styles.unscopeX}>
                    <Icon name="times" className={styles.icon} />
                  </div>
                </Link>
              )}
            </div>
          )}
        </GeoPillSponsor>
      </React.Fragment>
    );
  }
}

export default TripSearchGeoPillBinding(TripSearchGeoPill);
